module.exports = __webpack_public_path__ + "img/icon-3.a30b9a57.png";